import api from "./client";

export async function getPromoBar() {
  const { data } = await api.get("/api/promo-bar");
  return data.data;
}

export async function getAdminPromoBar() {
  const { data } = await api.get("/api/admin/promo-bar");
  return data.data;
}

export async function updatePromoBar(payload) {
  const { data } = await api.put("/api/admin/promo-bar", payload);
  return data.data;
}
